import { lazy } from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ProfileTalentPage = lazy(
  () => import('modules/performance_analytics/pages/profile/TalentPage')
)

const profileRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.profile.talent.path,
      element: <ProfileTalentPage />,
    },
  ]
}

export default profileRoutes
